'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.declineObservationsOverAttributes = undefined;
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var declineObservationsOverAttributes = exports.declineObservationsOverAttributes = function declineObservationsOverAttributes(attrsIds, observations) {
  var obsKeys = R.keys(observations);
  return R.reduce(function (acc, obsKey) {
    var obs = R.prop(obsKey, observations);
    var enhancedObs = R.pipe(R.over(R.lensProp('orderedDimIndexes'), R.append(0)), R.over(R.lensProp('attributes'), R.omit(attrsIds)), R.assocPath(['indexedDimValIds', 'OBS_ATTRIBUTES'], 'OBS_VALUE'))(obs);
    return R.addIndex(R.reduce)(function (_acc, attrId, attrIndex) {
      var attr = R.pathOr({}, ['attributes', attrId], obs);
      if (R.isEmpty(attr) || R.isNil(R.prop('value', attr)) || !R.pathOr(true, ['value', 'display'], attr)) {
        return _acc;
      }
      var declinedKey = obsKey + ':' + (attrIndex + 1);
      var declined = (0, _extends3.default)({}, obs, {
        attributes: {},
        value: R.prop('value', attr),
        formattedValue: R.prop('value', attr),
        orderedDimIndexes: R.append(attrIndex + 1, obs.orderedDimIndexes),
        indexedDimValIds: (0, _extends3.default)({}, obs.indexedDimValIds, {
          OBS_ATTRIBUTES: attr.id
        })
      });
      return R.assoc(declinedKey, declined, _acc);
    }, R.assoc(obsKey + ':0', enhancedObs, acc), attrsIds);
  }, {}, obsKeys);
};